import type { MediaFilePreview } from "./media-file-preview.interface";

export function mediaFilePreview(
  url: string | null | undefined,
): MediaFilePreview | null {
  const normalized = (url ?? "").trim().toLowerCase();
  if (!normalized) {
    return null;
  }
  if (
    normalized.includes("application/pdf") ||
    /\.pdf([?#]|$)/.test(normalized)
  ) {
    return { icon: "picture_as_pdf", label: "PDF" };
  }
  if (
    normalized.includes("application/msword") ||
    normalized.includes(
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ) ||
    /\.docx?([?#]|$)/.test(normalized)
  ) {
    return { icon: "description", label: "DOC" };
  }
  if (
    normalized.includes("application/vnd.ms-excel") ||
    normalized.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ) ||
    /\.xlsx?([?#]|$)/.test(normalized) ||
    normalized.includes("text/csv") ||
    /\.csv([?#]|$)/.test(normalized)
  ) {
    return { icon: "table_chart", label: "XLS" };
  }
  if (
    normalized.includes("application/zip") ||
    /\.zip([?#]|$)/.test(normalized)
  ) {
    return { icon: "folder_zip", label: "ZIP" };
  }
  if (normalized.includes("text/plain") || /\.txt([?#]|$)/.test(normalized)) {
    return { icon: "article", label: "TXT" };
  }
  if (
    normalized.includes("image/tiff") ||
    normalized.includes("image/tif") ||
    /\.tiff?([?#]|$)/.test(normalized)
  ) {
    return { icon: "image", label: "TIFF" };
  }
  if (normalized.startsWith("data:") && !normalized.startsWith("data:image/")) {
    return { icon: "insert_drive_file", label: "FILE" };
  }
  return null;
}
